<template>
  <div class="flex gap-[16px] items-center border-b border-[#e0e0e0]/[0.5] pb-[8px] mb-[8px] last:border-b-0 last:mb-0">
    <img
      :src="item.images_path ? item.images_path : 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'"
      alt="product"
      width="52"
      height="52"
    >
    <div class="flex gap-[8px] items-center justify-between w-full">
      <div>
        <div class="font-medium mb-[4px]">
          {{ item.product_name }}
        </div>
        <div class="text-primary text-[12px]">
          <span class="text-[#6e6b7b]">{{ item.variant_name || '-' }}</span> • <span>SKU: {{ item.sku }}</span>
        </div>
      </div>
      <div>
        <span class="font-medium">{{ item.qty }}x</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Component untuk menampilkan produk dalam bundle varian
 * @param {Object} item - Item produk
 * @param {string} item.product_name - Nama produk
 * @param {string} item.variant_name - Nama varian produk
 * @param {string} item.sku - SKU produk
 * @param {number} item.qty - Jumlah produk
 * @param {string} item.images_path - Path gambar produk
 */
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
